import { DOCUMENT, NgClass, NgOptimizedImage } from '@angular/common';
import { AfterViewChecked, Component, HostListener, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PAGE_DATA } from 'src/types/tokens/inject-tokens';

type SubMenuItems = {
  image: string;
  name: string;
  url: string;
};

@Component({
  standalone: true,
  selector: 'app-submenu',
  templateUrl: './submenu.component.html',
  styleUrls: ['./submenu.component.scss'],
  imports: [NgClass, RouterModule, NgOptimizedImage],
})
export class AppSubMenuComponent implements AfterViewChecked {
  private componentData: any = inject(PAGE_DATA, { optional: true });
  private doc = inject(DOCUMENT);

  items: SubMenuItems[] = [];
  isHorizScroll: boolean = false;

  constructor() {
    if (this.componentData.item) {
      this.items = this.componentData.item;
    }
  }

  horizScroll() {
    let docWidth = this.doc.getElementsByTagName('body')[0].clientWidth;
    let subcategories = this.doc.getElementsByClassName('subcategory-menu__item');
    let subcatArr = Array.from(subcategories);
    let scWidth = 0;
    subcatArr.forEach((subcategory) => {
      scWidth = scWidth + subcategory.clientWidth;
    });
    this.isHorizScroll = docWidth < scWidth;
  }

  @HostListener('window:resize', [])
  onResize() {
    this.horizScroll();
  }

  ngAfterViewChecked(): void {
    this.horizScroll();
  }
}
